<template>
  <a-modal
    :title="title"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
  >
    <template #footer>
      <a-button @click="handleCancel">取消</a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <!-- 检查单 -->
      <div class="inspect" v-if="reportType == '检查'">
        <div v-if="inspect.length > 0">
          <div class="inspectItem" v-for="(item,index) in inspect" :key="index">
            <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
              <a-col :span="24">
                <label>检查名称：{{ item.name }}</label>
              </a-col>
            </a-row>
          
            <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
              <a-col :span="12">
                <label>报告医生：{{ item.bgDoc }}</label>
              </a-col>
              <a-col :span="12">
                <label>审核医生：{{ item.shDoc }}</label>
              </a-col>
            </a-row>
          
            <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
              <a-col :span="24">
                <label>检查所见：{{ item.option1 }}</label>
              </a-col>
            </a-row>
          
            <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
              <a-col :span="24">
                <label>诊断意见：{{ item.checkSituation }}</label>
              </a-col>
            </a-row>
          
          </div>
        </div>
        <div v-else>
          <a-empty description="暂无报告"/>
        </div>
      </div>
      <!-- 检验单 -->
      <div class="sheet" v-else>
        <div v-if="sheet.length > 0">
          <div class="sheetItem" v-for="(item,index) in sheet" :key="index">
            <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
              <a-col :span="12">
                <label>套餐名称：{{ item.feeName }}</label>
              </a-col>
              <a-col :span="12">
                <label>申请医生：{{ item.sqDoc }}</label>
              </a-col>
            </a-row>
          
            <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
              <a-col :span="12">
                <label>检验中文名称：{{ item.itemNameCH }}</label>
              </a-col>
              <a-col :span="12">
                <label>检验英文名称：{{ item.itemNameEN }}</label>
              </a-col>
            </a-row>
          
            <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
              <a-col :span="12">
                <label>检验医生：{{ item.jyDoc }}</label>
              </a-col>
              <a-col :span="12">
                <label>审核医生：{{ item.shDoc }}</label>
              </a-col>
            </a-row>
          
            <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
              <a-col :span="12">
                <label>状态：{{ item.state }}</label>
              </a-col>
              <a-col :span="12">
                <label>单位：{{ item.unit }}</label>
              </a-col>
            </a-row>
          
            <a-row style="height:30px;padding: 0 10px;font-size: 13px;">
              <a-col :span="12">
                <label>结果：{{ item.result }}</label>
              </a-col>
              <a-col :span="12">
                <label>范围：{{ item.standard }}</label>
              </a-col>
            </a-row>
          </div>
        </div>
        <div v-else>
          <a-empty description="暂无报告" />
        </div>
        
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
  import { baSheetReportList } from '@/api/modular/interhospital/baSheet/baSheetManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        visible: false,
        confirmLoading: false,
        title: '检查单详情',
        reportType : '',
        queryFrom: {},
        inspect: [],
        sheet : [],
        form: this.$form.createForm(this)
      }
    },
    methods: {
      // 初始化方法
      add (record) {
        this.visible = true
        this.reportType = record.itemType
        console.log('查看报告类型', this.reportType )
        this.title = record.itemType == '检查' ? '检查单详情' : record.itemType == '检验' ? '检验单详情' : '检查单详情'
        this.getDetail(record)
      },
      
      /**
       * 获取报告详情
       */
      getDetail(record) {
        this.confirmLoading = true;
        this.queryFrom = {
          applyId: record.applyId == 'MC2302150152' && record.itemType == '检查' ? 'MC2208080171' : record.applyId == 'MY2302150267' && record.itemType == '检验' ? 'JY2212150651' : record.applyId ,
          itemType: record.itemType == '检查' ? 'B' : record.itemType == '检验'? 'C' : ''
        }
        this.visible = true
        baSheetReportList(this.queryFrom).then((res) => {
          console.log( '获取报告详情',res)
          if (res.success) {
            // this.$message.success('新增成功')
            this.confirmLoading = false

            if (res.data.length > 0) { 
              if (record.itemType == '检查') {
                this.inspect = res.data
              } else {
                this.sheet = res.data
              }
            } else {
              this.inspect = []
              this.sheet = []
              // if (record.itemType == '检查') {
              //   this.inspect = []
              // } else {
              //   this.sheet = []
              // }
            }

          } else {
            this.inspect = [];
            this.sheet = [];
            this.$message.error(res.message)// + res.message
          }
          console.log(this.inspect)
          console.log(this.sheet)
        }).finally((res) => {
          this.confirmLoading = false
        })
      },
      /**
       * 取消
       */
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
<style lang="less" scoped>
.sheetItem,.inspectItem{
  margin-bottom: 10px;
  border-bottom: 1px dotted #ccc;
}
</style>
